<template>
  <q-card class="q-pa-md">
    <q-form @submit="submit">
      <div class="text-bold text-center q-py-md">Add New 3rd Party Individual</div>

      <div class="col q-px-xs q-pb-md">
        <q-input
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          label="Third Party Name"
          v-model="thirdPartyName"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md">
        <q-input
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          mask="######-##-####"
          label="Third Party NRIC"
          v-model="thirdPartyNricOrOther"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md">
        <q-input
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          label="Third Party Mobile No."
          mask="###########"
          v-model="thirdPartyTelMobile"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md">
        <q-select
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          label="Third Party Relationship"
          v-model="thirdPartyRelationshipWithHolder"
          :options="thirdPartyRelationshipWithHolderList"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md" v-if="thirdPartyRelationshipWithHolder.label === 'Other'">
        <q-input
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          label="Define Other"
          v-model="thirdPartyRelationshipWithHolderOth"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md">
        <q-input
          outlined
          stack-label
          class="q-pb-none"
          color="primary"
          label="Third Party Purpose Of Transfer"
          v-model="thirdPartyPurpose"
          lazy-rules
          :rules="[ val => val !== '' && val !== null]"
        />
      </div>

      <div class="col q-px-xs q-pb-md">
        <azure-uploader
          ref="AzureUploader"
          label="Attach Proof Of Relationship"
          account="nadiablob"
          sas="?sv=2018-03-28&ss=bfqt&srt=sco&sp=rwdlacup&se=2023-05-07T08:43:39Z&st=2019-05-07T00:43:39Z&spr=https&sig=IkvEUVOmAdLCOyJpUKeQBjpWo7cw7hqVll%2FZQeokC0Y%3D"
          :containerName="bankAttachmentContainer"
          :path="customerId"
          accept=".jpg, .jpeg, .png, .pdf, .docx"
        />
      </div>

      <q-card-actions align="center">
        <q-btn label="Cancel" color="negative" @click="cancel" />
        <q-btn label="Submit" color="primary" type="submit" />
      </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import AzureUploader from "../azure-uploader/AzureUploader.vue";
import axios from 'axios'
export default {
  name: "AddNewThirdParty",

  props: {
    customerId: { type: String, required: true },
    env: { type: String, required: false, default: 'development' },
    apiUrl: { type: String, required: false },
    onboardingAPIToken: { type: String, required: true }
  },

  components: {
    AzureUploader
  },

  data() {
    return {
      thirdPartyName: "",
      thirdPartyNricOrOther: "",
      thirdPartyTelMobile: "",
      thirdPartyRelationshipWithHolder: "",
      thirdPartyRelationshipWithHolderList: [],
      thirdPartyRelationshipWithHolderOth: "",
      thirdPartyPurpose: ""
			
    };
  },

  methods: {
    submit() {
      if (!this.$refs.AzureUploader.isFilesAttached) {
        return alert("No proof of relationship attached.");
      }

      this.$refs.AzureUploader.upload()
        .then(resp => {
          this.$emit("submit", {
            Name: this.thirdPartyName,
            NRICorOther: this.thirdPartyNricOrOther,
            TelMobile: this.thirdPartyTelMobile,
            RelationshipWithHolder: this.thirdPartyRelationshipWithHolder.value,
            RelationshipWithHolderLabel: this.thirdPartyRelationshipWithHolder.label,
            RelationshipWithHolderOth: this.thirdPartyRelationshipWithHolderOth,
            Purpose: this.thirdPartyPurpose,
            ProofOfRelationshipFileData: '',
            ProofOfRelationshipFileName: resp.azure.filename,
            ProofOfRelationshipFileURL: resp.azure.blobName
          });
        })
        .catch(err => {
          console.log(err);
          return alert("Oops, something went wrong. Please try again shortly.");
        });
    },

    cancel() {
      this.$emit("cancel", "Cancel add new 3rd party.");
    }
  },

  computed: {
    bankAttachmentContainer() {
      return this.env === 'development' ? 'bankaccount-uat' : 'bankaccount'
    }
  },

  mounted() {

    // Onboarding API: Fetch form data
    axios({
      method: 'GET',
      url: this.apiUrl + '/onboarding/form/lookups',
      headers: { Authorization: 'Bearer ' + this.onboardingAPIToken }
    })
    .then(resp => {
      this.$set(this, 'thirdPartyRelationshipWithHolderList', resp.data.Relationship.map(v => {
        return {
          label: v.Name,
          value: v.Value
        }
      }))
    })
    .catch(err => console.log(err))

  }
};
</script>

<style>
</style>
